import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Badge list imported", { props: { triggerType: "Manual", event: "Post-show import" } }],
  ["up", "auto-update-contact", "Stamp the show and booth", { props: {} }],
  ["e1", "auto-email", "Great meeting you at the show", { props: { subject: "Following up from booth {{contact.booth}}" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["c1", "auto-condition", "Scored an A lead?", { props: { condition: "lead_grade is 'A'" } }],
  ["k1", "auto-task", "Call the A-leads personally", { props: { assignee: "Field sales", due: "+1 day" } }],
  ["e2", "auto-email", "The demo we talked about", { props: { subject: "The 4-minute version of what you saw" } }],
  ["w2", "auto-wait", "Wait 5 days", { props: { duration: "5", unit: "days" } }],
  ["e3", "auto-email", "Show pricing ends Friday", { props: { subject: "Show-only pricing closes Friday" } }],
  ["tg", "auto-tag-add", "Tag the show cohort", { props: { tag: "tradeshow-2026" } }],
]);

const def: TemplateDef = {
  slug: "trade-show-lead-followup",
  name: "Trade Show Lead Follow-Up",
  category: "Events",
  tagline:
    "Work the badge scans within 48 hours, while they still remember your booth.",
  description:
    "A free trade show follow-up template: the scanned badge list is injected as a cohort, stamped with the show and booth, then worked with a graded follow-up — personal calls for A-leads, a demo email for everyone, and a dated show-pricing close. Clone it into FrazzleCRM before the next event.",
  whatsInside: [
    "Direct-injection entry for the badge-scan or CSV import",
    "Show and booth stamped onto every contact for clean reporting",
    "Lead-grade branch so field sales only calls the A-list",
    "Show-pricing deadline email that closes the cohort",
  ],
  flow: makeFlow(
    [
      node("bs", "auto-inject", "Badge scans / CSV", 40, 140, { props: { source: "Show scanner export" } }),
      node("bo", "page-web", "Booth landing page", 40, 320, { props: { pageType: "landing", headline: "Scan for the show offer" } }),
      flow("f1", "Show Follow-Up", 360, 40, 420, 1040),
      ...seq.nodes,
      node("bk", "page-booking", "Book the demo", 880, 340, { props: { duration: "30 min" } }),
      node("out", "outcome-appointment", "Demo booked", 1200, 340),
      node("n1", "util-note", "48 hours or it's a list", 40, 500, {
        notes:
          "Badge scans decay faster than any other lead source — the show is the only context they have for you. If the first email lands a week later, you are cold-emailing people who paid to meet you.",
      }),
    ],
    [
      edge("bs", "f1"),
      edge("bo", "f1"),
      ...seq.edges,
      edge("f1", "bk"),
      edge("bk", "out"),
    ]
  ),
};

export default def;
